import * as Config from '../config';
import tpl from '../templates/team-member.html';
import template from 'lodash/template';
import isUndefined from 'lodash/isUndefined';

const compiledTPL = template(tpl);

export default class Video {
    constructor({el}) {
        if (Config.get('breakpoint') !== 0) {
            return;
        }

        this.data = {
            fullname: el.querySelector('h4').innerHTML,
            position: null,
            description: el.querySelector('.content-wrap p').innerHTML
        };

        const posEl = el.querySelector('.position');

        if (posEl) {
            this.data.position = posEl.innerHTML;
        }

        this.el = el;
        this.bind();
    }

    bindOverlay() {
        const overlay = document.querySelector('.overlay');

        document.querySelector('.overlay .close').addEventListener('click', evt => {
            evt.preventDefault();

            overlay.parentNode.removeChild(overlay);
        });

        document.body.addEventListener('keyup', evt => {
            if (evt.keyCode === 27 && this.open) {
                this.open = false;

                overlay.parentNode.removeChild(overlay);
            }
        });
    }

    bind() {
        this.el.addEventListener('click', evt => {
            evt.preventDefault();

            const node = document.createElement('div');

            node.className = 'overlay';
            node.innerHTML = compiledTPL({
                ...this.data,
                ...{
                    isUndefined
                }
            });

            document.body.appendChild(node);
            this.open = true;

            this.bindOverlay();
        });
    }
}
